import { apiService } from "api/apiService";
import type { FilterResource } from "api/generated";
import { myStudentsOverviewFromDto } from "meetings/student-meeting/api/mappers";
import type {
  MeetingMyStudentsOverview,
  MeetingMyStudentsOverviewDto,
} from "meetings/student-meeting/types";

export const fetchMentorClassStudentMeeting = async (
  mentorClass: string,
  params: Record<string, string> = {},
  signal?: AbortSignal,
): Promise<MeetingMyStudentsOverview> => {
  const url = `/api/my-students/${encodeURIComponent(mentorClass)}/student-meeting`;

  const { data } = await apiService.get<MeetingMyStudentsOverviewDto>(url, {
    params,
    signal,
  });

  return myStudentsOverviewFromDto(data);
};

export const fetchMentorClassStudentMeetingFilters = async (
  mentorClass: string,
  signal?: AbortSignal,
): Promise<FilterResource[]> => {
  const url = `/api/my-students/${encodeURIComponent(mentorClass)}/student-meeting/filters`;

  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(url, { signal });

  return filters;
};
